import { useLocation } from 'react-router-dom';
import { useEffect, useRef } from 'react';

export function usePreviousPath() {
  const { pathname } = useLocation();
  const prevRef = useRef(null);

  useEffect(() => {
    prevRef.current = pathname;
  }, [pathname]);

  return prevRef.current;
}
